<div class="preferences" data-test="preferences">
  <app-preferences-overview></app-preferences-overview>
</div>
